import React from 'react'
import Talleres from '!!file-loader?name=[name].[md4:hash:hex:6].[ext]!../../../../../src/common/assets/images/footer_others/icon_talleres.png'
import PagoSeguro from '!!file-loader?name=[name].[md4:hash:hex:6].[ext]!../../../assets/images/footer_others/icon_pago_seguro.svg'
// import Valoracion from '!!file-loader?name=[name].[md4:hash:hex:6].[ext]!../../../../../src/common/assets/images/footer_others/icon_valoracion.svg'
import MasterCard from '!!file-loader?name=[name].[md4:hash:hex:6].[ext]!../../../../../src/common/assets/images/footer_others/mc_vrt_pos.svg'
import Visa from '!!file-loader?name=[name].[md4:hash:hex:6].[ext]!../../../../../src/common/assets/images/footer_others/visa_inc_logo.svg'
import Amex from '!!file-loader?name=[name].[md4:hash:hex:6].[ext]!../../../../../src/common/assets/images/footer_others/logo-american-express.svg'
import styles from './miscellaneous.module.scss'

export default function Miscellaneous() {
  return (
    <div className={styles.miscel_big_container}>
      <div className={styles.miscel_container}>
        <img
          src={Talleres}
          className={`${styles.logo} ${styles.talleres}`}
          loading="lazy"
          alt="Talleres"
          width="240"
          height="70"
        />
        {/* <a
          className={`${styles.logo} ${styles.valoracion}`}
          href="https://www.csd.gob.es/es/promocion-del-deporte/universo-mujer-ii"
          rel="nofollow"
          target="_blank">
          <img
            loading="lazy"
            alt="Universo Mujer"
            src={UniversoMujer}
            width="144"
            height="76"
          />
        </a> */}
        <img
          className={`${styles.logo} ${styles.michelin}`}
          loading="lazy"
          alt="certificado calidad michelin"
          src="https://media.rodi.es/marca/michelin/certificado-calidad-michelin.png"
          width="159"
          height="77"></img>
        <img
          src={MasterCard}
          className={`${styles.logo} ${styles.mastercard}`}
          loading="lazy"
          width="183"
          height="150"
          alt="MasterCard"
        />
        <img
          src={Visa}
          className={`${styles.logo} ${styles.visa}`}
          loading="lazy"
          width="1000"
          height="300"
          alt="Visa"
        />       
        <img
          src={PagoSeguro}
          className={`${styles.logo} ${styles.pago}`}
          loading="lazy"
          width="150"
          height="55"
          alt="Pago seguro"
        />
        <img
          src={Amex}
          className={`${styles.logo} ${styles.amex}`}
          loading="lazy"
          width="1000"
          height="300"
          alt="Amex"
        />         
      </div>
    </div>
  )
}
